import type { ReactNode } from "react";

import { LeadsDetailsByCountryTooltip } from "../components/cells/LeadslDetailsByCountryTooltip";
import type { LeadsSearchRow } from "../types";

import { resolveColumnValueFormatter } from "./column-value";

type RenderFn<R extends LeadsSearchRow> = (value: R[keyof R], record: R, index: number) => ReactNode;

export const wrapColumnWithDetailsByCountryTooltip = <R extends LeadsSearchRow>(
    dataIndex: keyof R,
    originalRender: RenderFn<R>,
): RenderFn<R> => {
    const formatFn = resolveColumnValueFormatter(dataIndex);

    return function WrappedCell(value: R[keyof R], record: R, index: number) {
        return (
            <LeadsDetailsByCountryTooltip<R>
                dataIndex={dataIndex}
                record={record}
                formatFn={formatFn}
            >
                {originalRender(value, record, index)}
            </LeadsDetailsByCountryTooltip>
        );
    };
};
